<script>
import { BDropdownGroup } from "bootstrap-vue";

export default {
  extends: BDropdownGroup
};
</script>